import { isImpersonationSession } from "@src/appV2/Auth/Impersonation/context";
import { ZendeskSDK } from "capacitor-zendesk-sdk/dist/esm";

import { APP_V2_APP_EVENTS, logEvent } from "../analytics";
import { isCapacitorPlatform } from "../utils";
import { setZendeskMessagingUnread } from "./utils";

declare global {
  interface Window {
    zE: (x: string, y: string, z?: (callback: (token?: string) => void) => void) => void;
  }
}

export async function openZendeskMessaging() {
  if (isImpersonationSession()) {
    logEvent(APP_V2_APP_EVENTS.ZENDESK_CHAT_OPENED, {
      blocked: true,
      reason: "impersonation_session",
    });
    return;
  }

  logEvent(APP_V2_APP_EVENTS.ZENDESK_CHAT_OPENED);
  setZendeskMessagingUnread(false);

  if (isCapacitorPlatform()) {
    await ZendeskSDK.showMessaging();
  } else {
    // FIXME: Automatically disabled during ESLint config update
    window.zE("messenger", "open");
    // FIXME: Automatically disabled during ESLint config update
    window.zE("messenger", "show");
    // FIXME: Automatically disabled during ESLint config update
    window.zE("messenger:on", "close", () => {
      // FIXME: Automatically disabled during ESLint config update
      window.zE("messenger", "hide");
    });
  }
}
